import React, { Component } from 'react';
import ObjectPickerDialog from '../../common/ObjectPicker/ObjectPickerDialog';
import UserSearchCard from './UserSearchCard';
import { Button, Pane, Heading } from 'evergreen-ui';

import Request from '../../../util/Api';

import Config from '../Config';
import UserListCard from './UserListCard';



class UserPicker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showSearch: false
        }
    }

    toggleSearch(show = true) {
        this.setState({
            showSearch: show
        })
    }

    searchFunction(value) {
        return Request.get(Config.Endpoints.users, null, {q: value});
    }

    mapperFunction(value) {
        return value.data.map(entry => ({...entry, name: entry.title}));
    }

    handleSubmit = (selection) => {
        this.props.onSubmit(selection);
    }

    handleDelete = (product) => {
        const values = this.props.values.filter(value => value !== product);
        this.props.onSubmit(values);
    }


    render() {
        return (<Pane>
                <ObjectPickerDialog
                    label="Selecteaza unul sau mai multi utilizatori"
                    open={!!this.state.showSearch}
                    onClose={() => { this.toggleSearch(false); }}
                    onSubmit={(selection) => { this.handleSubmit(selection); }}
                    searchFunction = {this.searchFunction}
                    mapFunction = {this.mapperFunction}
                    resultComponent = {(props) => <UserSearchCard {...props}/>}/>

                <Button 
                    appearance="primary"
                    iconBefore="add"
                    type="button"
                    onClick={() => { this.toggleSearch(true)}}>
                    {this.props.single ? "Selecteaza Utilizator" : "Adauga Utilizatori"}
                </Button>
                
                {this.props.minimal ? null : 
                    <Pane>
                        <Pane paddingBottom={8} marginBottom={8} borderBottom="default">
                            <Heading size={400}>Utilizatori Selectati</Heading>
                        </Pane>
                        <Pane>
                            {this.props.values.length === 0 ? 
                                <Heading size={400}>Niciun utilizator adaugat</Heading> : 
                                null}
                            {this.props.error ? 
                                <Heading size={300} color="red">{this.props.error}</Heading> : null}

                            {(this.props.values || []).map(user => <UserListCard 
                                key={`user-picker-${user.id}`} 
                                user={user} 
                                onDelete={() => this.handleDelete(user)}/>)}
                        </Pane>
                    </Pane>}
                
            </Pane>
        );
    }

}

export default UserPicker;